import React from 'react';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  className?: string;
}

export const Textarea: React.FC<TextareaProps> = ({ 
  className = '',
  disabled,
  ...props
}) => {
  const baseClasses = 'block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm';
  const disabledClasses = disabled ? 'cursor-not-allowed opacity-50 bg-gray-50' : '';
  
  return (
    <textarea
      className={`${baseClasses} ${disabledClasses} ${className}`}
      disabled={disabled}
      {...props}
    />
  );
};